import React, { useContext } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import { ParametersContext } from 'components/ParametersGuard';
import ClaimsTable from 'components/claims/ClaimsPage/ClaimsTable';
import { Claim } from 'store/types/Claim';
import ClaimsTableType from 'store/enums/ClaimsTableType';
import ClaimUploadType from 'store/enums/ClaimUploadType';
import { defaultGridContainerProps, defaultGridItemProps } from 'util/Layout';

import styles from 'components/claims/ClaimsPage/ClaimsPage.module.scss';

interface Props {
  myClaims?: Claim[];
  claimsAgainstMe?: Claim[];
  loading?: boolean;
  onApplicationCreateClick: (applicationId: string) => void;
  onApplicationDeleteClick?: (claim: Claim) => void;
  onDisputeClaimClick?: (claim: Claim) => void;
  onFileUploadClick?: (claim: Claim, uploadType: ClaimUploadType) => void;
}

const ActiveClaimsTab: React.FunctionComponent<Props> = ({
  myClaims,
  claimsAgainstMe,
  loading,
  onApplicationCreateClick,
  onApplicationDeleteClick,
  onDisputeClaimClick,
  onFileUploadClick,
}) => {
  const {
    claims: { claimsApplicationTypeId, myClaimsTableHeader, claimsAgainstMeTableHeader },
  } = useContext(ParametersContext);

  return (
    <Grid {...defaultGridContainerProps}>
      <Grid {...defaultGridItemProps}>
        <Box sx={{ display: 'flex' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() => onApplicationCreateClick(claimsApplicationTypeId ?? '')}
          >
            Submit New Claim
          </Button>
        </Box>
      </Grid>
      <Grid {...defaultGridItemProps}>
        <Typography variant="h2" className={styles.tableTitle}>
          {'Filed'}
        </Typography>
        {myClaimsTableHeader && <p dangerouslySetInnerHTML={{ __html: myClaimsTableHeader }} />}
        <ClaimsTable
          tableType={ClaimsTableType.MyClaims}
          data={myClaims}
          loading={loading}
          onApplicationDeleteClick={onApplicationDeleteClick}
          onDisputeClaimClick={onDisputeClaimClick}
          onFileUploadClick={onFileUploadClick}
        />
      </Grid>
      <Grid {...defaultGridItemProps}>
        <Typography variant="h2" className={styles.tableTitle}>
          {'Filed Against Me'}
        </Typography>
        {claimsAgainstMeTableHeader && <p dangerouslySetInnerHTML={{ __html: claimsAgainstMeTableHeader }} />}
        <ClaimsTable
          tableType={ClaimsTableType.ClaimsAgainstMe}
          data={claimsAgainstMe}
          loading={loading}
          onDisputeClaimClick={onDisputeClaimClick}
          onFileUploadClick={onFileUploadClick}
        />
      </Grid>
    </Grid>
  );
};

export default ActiveClaimsTab;
